export enum addOption {
	Contact = "Contacto",
	Company = "Empresa",
	New = "Novedad",
}
